import { useSelector } from 'react-redux'
import { isGpsOnly } from '@/features/domain/user'

export const useIsVisible = () => useSelector(isGpsOnly)
